export function checkIsEmpty(value: string) {
  return value.replace(/\s/g, '') === ''
}